import { cdnImages } from "@/lib/cdn-images";

export type TeacherId =
  | "rajwant"
  | "vipin"
  | "pankaj"
  | "manish"
  | "samapti"
  | "tulika"
  | "sujeet"
  | "hitesh";

export const teacherPool: Record<TeacherId, { name: string; image: string }> = {
  rajwant: { name: "Rajwant Sir", image: cdnImages.educators.rajwant },
  // No CDN asset published for Vipin yet; still served locally.
  vipin: { name: "Vipin Sharma Sir", image: "/educators/vipin.png" },
  pankaj: { name: "Pankaj Sir", image: cdnImages.educators.pankaj },
  manish: { name: "Manish Raj Sir", image: cdnImages.educators.manish },
  samapti: { name: "Samapti Ma'am", image: cdnImages.educators.samapti },
  tulika: { name: "Tulika Jha Ma'am", image: cdnImages.educators.tulika },
  sujeet: { name: "Sujeet Tripathi Sir", image: cdnImages.educators.sujeet },
  hitesh: { name: "Hitesh Sopra Sir", image: cdnImages.educators.hitesh },
};

export type ExamName =
  | "JEE"
  | "NEET"
  | "GATE"
  | "Defence (NDA/CDS/AFCAT)"
  | "Class 9–12";

export type ExamDetail = {
  lectures: string[];
  practice: string[];
  teachers: Array<{ id: TeacherId; subject: string }>;
};

export const examData: Record<ExamName, ExamDetail> = {
  JEE: {
    lectures: ["Pocket Course", "Mindmaps", "Diagram series", "Detailed courses"],
    practice: ["DPPs", "All PYQs", "Full-length mocks"],
    teachers: [
      { id: "rajwant", subject: "Physics" },
      { id: "pankaj", subject: "Maths" },
      { id: "manish", subject: "Inorganic Chemistry" },
      { id: "sujeet", subject: "Organic Chemistry" },
      { id: "hitesh", subject: "Physics" },
    ],
  },
  NEET: {
    lectures: [
      "Class 11 & 12 Biology",
      "Physics",
      "Physical & Organic Chemistry",
      "NCERT line-by-line",
    ],
    practice: ["Daily DPPs", "NEET PYQs 2010–2025", "Full mock tests"],
    teachers: [
      { id: "tulika", subject: "Biology" },
      { id: "samapti", subject: "Physical Chemistry" },
      { id: "manish", subject: "Inorganic Chemistry" },
      { id: "sujeet", subject: "Organic Chemistry" },
    ],
  },
  GATE: {
    lectures: ["Core engineering subjects", "Engineering Maths", "General Aptitude"],
    practice: ["Subject-wise DPPs", "GATE PYQs", "Full mocks"],
    teachers: [
      { id: "pankaj", subject: "Engineering Maths" },
      { id: "vipin", subject: "Core Physics" },
    ],
  },
  "Defence (NDA/CDS/AFCAT)": {
    lectures: ["Maths", "General Knowledge", "English", "Reasoning"],
    practice: ["NDA/CDS PYQs", "Daily quizzes", "Full-length mocks"],
    teachers: [
      { id: "pankaj", subject: "Maths" },
      { id: "vipin", subject: "GS · Physics" },
    ],
  },
  "Class 9–12": {
    lectures: [
      "All subjects, NCERT-aligned",
      "Board-focused lectures",
      "Chapter one-shots",
    ],
    practice: ["Chapter DPPs", "Sample papers", "Board PYQs"],
    teachers: [
      { id: "vipin", subject: "Physics" },
      { id: "pankaj", subject: "Maths" },
      { id: "tulika", subject: "Biology" },
      { id: "manish", subject: "Chemistry" },
    ],
  },
};

export const examNames = Object.keys(examData) as ExamName[];
